module.exports = __webpack_public_path__ + "static/media/bg-home-animated.376ad7cf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-home-animated.mp4
// module id = 335
// module chunks = 0